import brandPortalOrders from "@faire/web-api/routes/brand-portal/orders";
import { Button } from "@faire/web/slate/Button";
import { Column } from "@faire/web/slate/Layout";
import { Spacer } from "@faire/web/slate/spacing";
import { Typography } from "@faire/web/slate/Typography";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import React from "react";
import { Bold } from "../common/Bold";
import { LiItem } from "../common/LiItem";
export var CannotFindAnOrderIA = function CannotFindAnOrderIA() {
  return /*#__PURE__*/React.createElement(Column, null, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "qs+yOq",
    defaultMessage: [{
      "type": 0,
      "value": "Se estiver a ter dificuldades em encontrar a encomenda de um revendedor na sua conta Faire, pode dever-se a alguns motivos diferentes. Aqui estão alguns passos que pode tomar para resolver este problema:"
    }]
  })), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement("ol", null, /*#__PURE__*/React.createElement(LiItem, {
    step: 1
  }, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "8Hf+hC",
    defaultMessage: [{
      "children": [{
        "type": 0,
        "value": "A encomenda ainda está a ser processada:"
      }],
      "type": 8,
      "value": "BoldFormatting"
    }],
    values: {
      BoldFormatting: function BoldFormatting(chunks) {
        return _BoldFormatting(chunks);
      }
    }
  })), /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "+J5CGL",
    defaultMessage: [{
      "type": 0,
      "value": "Peça ao revendedor que forneça quaisquer informações adicionais sobre a respetiva conta e incentive-o a contactar-nos diretamente para obter mais assistência."
    }]
  }))), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement(LiItem, {
    step: 2
  }, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "Q7Q0DJ",
    defaultMessage: [{
      "children": [{
        "type": 0,
        "value": "Números de encomenda diferentes:"
      }],
      "type": 8,
      "value": "BoldFormatting"
    }],
    values: {
      BoldFormatting: function BoldFormatting(chunks) {
        return _BoldFormatting(chunks);
      }
    }
  })), /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "s5nkQH",
    defaultMessage: [{
      "type": 0,
      "value": "Se um revendedor lhe fornecer um número de encomenda que não apareça na sua página de "
    }, {
      "children": [{
        "type": 0,
        "value": "Encomendas"
      }],
      "type": 8,
      "value": "LinkFormatting"
    }, {
      "type": 0,
      "value": ", peça-lhe o respetivo "
    }, {
      "children": [{
        "type": 0,
        "value": "número de fatura"
      }],
      "type": 8,
      "value": "BoldFormatting"
    }, {
      "type": 0,
      "value": ". O número da fatura deve corresponder ao número da encomenda que vê, permitindo-lhe localizar a encomenda."
    }],
    values: {
      LinkFormatting: function LinkFormatting(chunks) {
        return OrderLinkFormatting(chunks);
      },
      BoldFormatting: function BoldFormatting(chunks) {
        return _BoldFormatting(chunks);
      }
    }
  }))), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement(LiItem, {
    step: 3
  }, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "JDfmRL",
    defaultMessage: [{
      "children": [{
        "type": 0,
        "value": "Novas contas em análise:"
      }],
      "type": 8,
      "value": "BoldFormatting"
    }],
    values: {
      BoldFormatting: function BoldFormatting(chunks) {
        return _BoldFormatting(chunks);
      }
    }
  })), /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "PDY+PO",
    defaultMessage: [{
      "type": 0,
      "value": "Se um revendedor tiver fornecido o respetivo número de fatura, mas ainda não conseguir encontrar a respetiva encomenda, é possível que a conta do revendedor seja nova e esteja suspensa enquanto a nossa equipa analisa as respetivas informações. Este processo de análise não deve demorar mais do que alguns dias."
    }]
  })))), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "IkPzxw",
    defaultMessage: [{
      "type": 0,
      "value": "Se tiver verificado o indicado acima e ainda não conseguir localizar a encomenda, contacte-nos para obter mais assistência. Estamos aqui para ajudar a resolver estes problemas."
    }]
  })));
};
var OrderLinkFormatting = function OrderLinkFormatting(chunks) {
  return /*#__PURE__*/React.createElement(Button, {
    variant: "tertiary",
    linkTo: brandPortalOrders(),
    target: "_blank"
  }, /*#__PURE__*/React.createElement(Bold, null, chunks));
};
var _BoldFormatting = function _BoldFormatting(chunks) {
  return /*#__PURE__*/React.createElement(Bold, null, chunks);
};